'use client';

import { Box } from '@viewup/ui';
import type { ReactNode } from 'react';

interface MobileFrameProps {
  children: ReactNode;
}

export const MobileFrame = ({ children }: MobileFrameProps) => {
  return (
    // biome-ignore lint/correctness/useUniqueElementIds: <container 지정을 위해 찾아서 사용해야 하기 때문에 wrapper 키 설정>
    <Box
      css={{
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 0px 8px',
        container: 'container / inline-size',
        height: '100svh',
        margin: '0 auto',
        maxWidth: 440,
        overflow: 'hidden',
        position: 'relative',
        transform: 'scale(1)',
        width: '100%',
      }}
      id='wrapper'
    >
      {children}
    </Box>
  );
};
